<template>
  <div class="mark-wrap">
    <div class="mark-list">
      <div class="mark-inner" v-for="(i, index) in 1000" :key="index">
        <div>{{ waterMarkText }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        showWaterMark: false,
        waterMarkText: ''
      };
    },
    computed: {},
    props: {},
    mounted() {
      this.getWaterMarkText();
    },
    methods: {
      getWaterMarkText() {
        const userInfo = localFun.get('userInfo')
          ? JSON.parse(localFun.get('userInfo'))
          : {};
        const watermarkConfigSelected = localFun.get('watermarkConfigSelected')
          ? JSON.parse(localFun.get('watermarkConfigSelected'))
          : [];

        const optionsArray = [
          'name',
          'jobNumber',
          'phoneNumber',
          'email',
          'department'
        ];
        //按照原型顺序对勾选字段进行排序
        this.toOrderArray(optionsArray, watermarkConfigSelected);
        if (watermarkConfigSelected.length > 0) {
          watermarkConfigSelected.map((item) => {
            if (userInfo[item]) {
              this.waterMarkText += userInfo[item];
            }
          });
        }
      },
      toOrderArray(options, selectItems) {
        let optionValues = options.map(function (a) {
          return a;
        });
        return selectItems.sort(function (a, b) {
          return optionValues.indexOf(a) - optionValues.indexOf(b);
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
  .mark-wrap {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 2000;
    background: rgba(0, 0, 0, 0);
    pointer-events: none;

    .mark-list {
      width: 200%;
      height: 300%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) rotate(-45deg);

      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      word-break: break-all;
      pointer-events: none;

      // background: #f0f;

      .mark-inner {
        font-size: 14px;
        color: rgba(51, 51, 51, 0.1);
        padding: 40px;
        line-height: 20px;
        max-width: 180px;
        box-sizing: content-box;
        pointer-events: none;
      }
    }
  }
</style>
